<template>
	<app-header-teleport>
		<div class="flex flex-1 items-center">
			<app-title :title="$t('financePayments')" />
			<div class="ml-2">
				<app-advanced-filter @onFilter="onFilter" @onClear="onClear" :loading="isLoading">
					<app-advanced-date-filter v-model="filters" :start-date="'startDate'" :end-date="'endDate'" />
				</app-advanced-filter>
			</div>
		</div>
	</app-header-teleport>
	<app-section class="tight mt-4">
		<payment-table :payments="payments" />
		<app-pagination
			:filters="searchFilters"
			@prevPage="prevPage"
			@nextPage="nextPage"
			@limitChange="changeLimit"
			:loading="isLoading"
		/>
	</app-section>
</template>

<script>
	import AppAdvancedFilter from '@/components/app/AppAdvancedFilter';
	import AppAdvancedDateFilter from '@/components/app/AppAdvancedDateFilter';
	import AppPagination from '@/components/app/AppPagination';
	import constants from '@/constants/finance';
	import FinanceService from '@/services/FinanceService';
	import PaymentTable from '@/components/finance/PaymentTable';
	import { mapGetters } from 'vuex';

	export default {
		name: 'Payments',
		components: {
			PaymentTable,
			AppAdvancedFilter,
			AppAdvancedDateFilter,
			AppPagination,
		},
		data: () => ({
			isLoading: false,
			filters: { ...constants.paymentsDefaultFilters },
			searchFilters: { ...constants.paymentsDefaultFilters },
			paymentColumns: constants.paymentColumns,
			payments: [],
		}),
		computed: {
			...mapGetters({
				selectedRestaurants: 'selectedRestaurants',
			}),
		},
		methods: {
			getPayments() {
				this.isLoading = true;
				FinanceService.getPayments({
					...this.searchFilters,
					invoiceId: this.filters.invoiceId || -1,
					businessIDs: this.selectedRestaurants.join('-'),
				})
					.then((payments) => {
						this.payments = payments;
					})
					.catch((e) => this.$notificationService.error(e))
					.finally(() => {
						this.isLoading = false;
						this.emitter.emit('isLoading', false);
					});
			},
			onFilter() {
				this.searchFilters = { ...this.filters };
				this.refresh();
			},
			onClear() {
				this.filters = { ...constants.defaultFilters };
				this.searchFilters = { ...constants.defaultFilters };
				this.refresh();
			},
			prevPage() {
				this.searchFilters.offset = Math.max(this.searchFilters.offset - this.searchFilters.limit, 0);
				this.getPayments();
			},
			nextPage() {
				this.searchFilters.offset = this.searchFilters.offset + this.searchFilters.limit;
				this.getPayments();
			},
			changeLimit(value) {
				this.searchFilters = {
					...this.searchFilters,
					limit: value,
					offset: 0,
				};
				this.getPayments();
			},
			refresh() {
				this.getPayments();
			},
		},
		mounted() {
			this.emitter.emit('isLoading', true);
			this.refresh();
		},
		watch: {
			selectedRestaurants() {
				if (!this.$store.getters.token) return;
				this.refresh();
			},
		},
	};
</script>
